import React from "react";
import { Lock, Zap, Megaphone } from "lucide-react";

export default function EarlyAccessSection({ count = 124 }) {
  return (
    <section
      id="early-access"
      className="nm-section-light reveal-section"
      data-reveal
      data-testid="early-access-section"
    >
      <div className="nm-container py-20 md:py-24">
        {/* Eyebrow */}
        <span className="nm-eyebrow inline-block text-black/50 mb-6">
          Early Access
        </span>

        {/* Section Header */}
        <div className="mb-12">
          <h2 className="text-[clamp(2.2rem,5vw,3.8rem)] text-black leading-none mb-4">
            The first 500 get in free.
          </h2>
          <p className="text-sm text-black/60 max-w-sm leading-relaxed font-medium">
            No payment. No credit card. No excuses accepted.
          </p>
        </div>

        {/* Grid of 3 Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Card 1 */}
          <div className="bg-white border border-black/10 rounded-2xl p-5 md:p-6 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(0,0,0,0.05)] hover:border-black/20">
            <div>
              <div className="w-10 h-10 rounded-xl bg-black/[0.03] flex items-center justify-center mb-5 text-black">
                <Lock size={20} strokeWidth={2.5} />
              </div>
              <h3 className="text-base md:text-lg font-extrabold text-black mb-2 font-['Space_Grotesk']">
                Beta Access
              </h3>
              <p className="text-[13px] md:text-[14px] text-black/65 leading-relaxed">
                Free for the first 500 users. No credit card. No catch.
              </p>
            </div>
            <div className="mt-6 flex">
              <span className="text-[10px] md:text-[11px] font-extrabold text-emerald-600 bg-emerald-500/10 px-3.5 py-1.5 rounded-xl md:rounded-full text-center tracking-wider uppercase leading-tight">
                {count} of 500 founding spots claimed
              </span>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white border border-black/10 rounded-2xl p-5 md:p-6 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(0,0,0,0.05)] hover:border-black/20">
            <div>
              <div className="w-10 h-10 rounded-xl bg-black/[0.03] flex items-center justify-center mb-5 text-black">
                <Zap size={20} strokeWidth={2.5} />
              </div>
              <h3 className="text-base md:text-lg font-extrabold text-black mb-2 font-['Space_Grotesk']">
                Full AI Engine
              </h3>
              <p className="text-[13px] md:text-[14px] text-black/65 leading-relaxed">
                Complete accountability experience from day one. No lite version, no feature gates.
              </p>
            </div>
            <div className="mt-6 flex">
              <span className="text-[10px] md:text-[11px] font-extrabold text-emerald-600 bg-emerald-500/10 px-3.5 py-1.5 rounded-xl md:rounded-full text-center tracking-wider uppercase leading-tight">
                AI-DRIVEN ACCOUNTABILITY ENGINE
              </span>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white border border-black/10 rounded-2xl p-5 md:p-6 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(0,0,0,0.05)] hover:border-black/20">
            <div>
              <div className="w-10 h-10 rounded-xl bg-black/[0.03] flex items-center justify-center mb-5 text-black">
                <Megaphone size={20} strokeWidth={2.5} />
              </div>
              <h3 className="text-base md:text-lg font-extrabold text-black mb-2 font-['Space_Grotesk']">
                Shape the Product
              </h3>
              <p className="text-[13px] md:text-[14px] text-black/65 leading-relaxed">
                Your feedback directly influences what gets built next. Founding members get heard.
              </p>
            </div>
            <div className="mt-6 flex">
              <span className="text-[10px] md:text-[11px] font-extrabold text-emerald-600 bg-emerald-500/10 px-3.5 py-1.5 rounded-xl md:rounded-full text-center tracking-wider uppercase leading-tight">
                LIFETIME DISCOUNT FOR FOUNDING MEMBERS
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
